import { useQuery } from '@tanstack/react-query';

import fetchSelloutMonitoring from '@data/selloutMonitoring/fetchSelloutMonitoring';

const getSelloutMonitoring = ({ queries, enabled }) => {
    return useQuery({
        enabled,
        queryKey: ['sellout-monitoring', queries],
        queryFn: () => fetchSelloutMonitoring({ queries }),
    });
};

export default getSelloutMonitoring;
